/**
 * `onReady` handler for `NavigationContainer` in `@react-navigation/native`
 * Since we are using `react-router` on web, stub this out
 */
export const onReady = () => {};
